import React, { useState, useEffect, lazy, Suspense } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
const LanguageSelectModal = lazy(() => import("../modal/modal_language.js"));

const LanguageSelector = ({ setLang }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return Cookies.get("lang"); // Зчитування мови з кукі або встановлення "IT" за замовчуванням
    });

    const [showLanguageModal, setShowLanguageModal] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        const handleLanguageChange = () => {
            const newLang = Cookies.get("lang");
            setLang(newLang);
            setSelectedLanguage(newLang); // Оновлюємо вибрану мову
        };

        // Слухаємо подію для оновлення мови в інших компонентах
        window.addEventListener("languageChange", handleLanguageChange);

        return () => {
            window.removeEventListener("languageChange", handleLanguageChange);
        };
    }, []);

    const handleOpenLanguageModal = () => setShowLanguageModal(true); // Відкриваємо модальне вікно
    const handleCloseLanguageModal = () => setShowLanguageModal(false); // Закриваємо модальне вікно

    const handleLanguageChange = (language) => {
        setSelectedLanguage(language); // Оновлюємо локальний стан кнопки
        setLang(language);
        Cookies.set("lang", language, { expires: 365 }); // Зберігаємо мову в кукі

        // Створюємо подію для оновлення всіх компонентів
        const event = new Event("languageChange");
        window.dispatchEvent(event);

        setShowLanguageModal(false); // Закриваємо модальне вікно після вибору мови
    };

    const flagSrc = `/flags/4x3/${selectedLanguage === "en" ? "us" : selectedLanguage}.svg`;

    return (
        <>
            <a className="language" onClick={handleOpenLanguageModal}>
                <span>{Cookies.get("lang")}</span>
                <img src={flagSrc} alt={`${Cookies.get("lang")} Flag`} />
            </a>

            <Suspense fallback={<div>{t("loading")}...</div>}>
                {showLanguageModal && (
                    <LanguageSelectModal
                        show={showLanguageModal}
                        handleClose={handleCloseLanguageModal}
                        handleLanguageChange={handleLanguageChange}
                        selectedLanguage={selectedLanguage}
                    />
                )}
            </Suspense>
        </>
    );
};

export default LanguageSelector;
